import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./ArticlePage.module.scss";
import Layout from "../../Components/Layout/Layout";
import Wrapper from "../../Components/Layout/Wrapper";
import Search from "../../Components/Search/Search";
import ScrollTopButton from "../../Components/Button/ScrollTopButton";
import Button from "../../Components/Button/Button";
import writer_icon from "../../Assets/Images/writer.png";
import date_icon from "../../Assets/Images/date.png";
import BasicAPI from "../../API/BasicAPI";

const ArticlePage = () => {
  const { id } = useParams();
  const [article, setArticle] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    BasicAPI({
      url: `${process.env.REACT_APP_SERVICE_URL}/article/articles/${id}`,
      method: "GET",
      success: (res) => setArticle(res),
      fail: (res) => console.error(res),
    });
  }, []);

  console.log(article);

  return (
    <Layout>
      <Search />
      <Wrapper>
        <div className={styles.article_wrapper}>
          <div className={styles.title_wrapper}>
            <div className={styles.title}>{article.title}</div>
            <div className={styles.info_wrapper}>
              <div className={styles.writer_wrapper}>
                <img src={writer_icon} alt="기자명" />
                {article.reporter}
              </div>
              <div className={styles.date_wrapper}>
                <img src={date_icon} alt="작성날짜" />
                <div className={styles.date}>{article.created_at}</div>
              </div>
            </div>
          </div>
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: article.content,
            }}
          ></div>
          {/* <div className={styles.content_wrapper}>
            <div className={styles.thumbnail_wrapper}>
              <img src={article.thumbnail} alt="기사 썸네일" />
              <div className={styles.description}>
                이미지 설명 = {article.thumbnail_description}
              </div>
            </div>
            <div className={styles.text_wrapper}>{article.content}</div>
            {article.ad_banner && article.ad_banner.length !== 0 && (
              <div className={styles.banner_wrapper}>
                <img src={article.ad_banner[0].file} alt="광고 배너" />
              </div>
            )}
          </div> */}
          <div className={styles.btn_wrapper}>
            <Button type="blue" text="돌아가기" onClick={() => navigate(-1)} />
          </div>
        </div>
      </Wrapper>
      <ScrollTopButton />
    </Layout>
  );
};

export default ArticlePage;
